// extracted by mini-css-extract-plugin
export var actionButton = "_xb-2";
export var card = "_xb-0";
export var disambiguationList = "_xb-3";
export var errorCard = "_xb-4";
export var row = "_xb-1";